module.exports = __webpack_public_path__ + "img/sms-with-a-gift.ebdd3cdb.png";